import { InvestmentScenariiService } from './../../../../@core/utils/investment-scenarii.service';
import { RightPanelDialogService } from './../../../../@core/utils/right-panel-dialog.service';
import { GROUP_PERMISSION_ACCESS_AUDIT, IdNameMixin } from './../../../../@core/api/models';
import { InvestmentsService } from './../../../../@core/utils/investments.service';
import { AssetsService } from './../../../../@core/utils/assets.service';
import { UsersService } from './../../../../@core/utils/users.service';
import { InitiativesService } from './../../../../@core/utils/initiatives.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseFormComponent } from '../base-form/base-form.component';
import { NbDialogRef, NbDialogService, NbCardModule, NbSpinnerModule, NbButtonModule, NbTooltipModule, NbInputModule, NbSelectModule, NbOptionModule, NbAccordionModule, NbAutocompleteModule, NbDatepickerModule } from '@nebular/theme';
import { KPI } from '../../../../@core/api';
import { FormArray, FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { ChartsService, ConfigService, I18nService, InitiativesChangesService, InvestmentsChangesService, InvestmentStatusesService, RoadmapService, SaveToastService, ScopeService } from '../../../../@core/utils';
import { Observable, combineLatest, of } from 'rxjs';
import { LoadingState } from '../../../../@core/api/models';
import { catchError, debounceTime, filter, first, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { idMapToArray, toLoadingState } from '../../../../@core/utils/scope.service';
import { DatePipe, NgClass, AsyncPipe, formatNumber, CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UsernamePipe } from '../../../pipes/username.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InitiativeGainsFormComponent } from './initiative-gains-form/initiative-gains-form.component';
import { InvestmentFormComponent } from '../investment-form/investment-form.component';
import { CurrencyPipe } from '../../../pipes';
import { InitiativeResponsiblesService } from './../../../../@core/utils/initiative-responsibles.service';
import { SheetDialogComponent } from '../../sheet-dialog/sheet-dialog.component';
import { BasicDialogComponent } from '../../basic-dialog/basic-dialog.component';
import { LinkableInvestmentsListComponent } from '../linkable-investments-list/linkable-investments-list.component';
import { EntityDocumentsTabComponent } from '../../entity-documents-tab/entity-documents-tab.component';
import { DocumentsService } from '../../../../@core/utils';
import { gainValidator } from './initiative-gain.validator';
import { toDateValue, toIsoMonthStartDate } from '../../../utils/date.utils';

@Component({
  selector: 'app-initiative-form',
  templateUrl: './initiative-form.component.html',
  styleUrls: [
    '../base-form/base-form.component.scss',
  ],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NbCardModule,
    NgClass,
    NbSpinnerModule,
    NbButtonModule,
    NbTooltipModule,
    FontAwesomeModule,
    NbInputModule,
    NbSelectModule,
    NbOptionModule,
    NbAccordionModule,
    NbDatepickerModule,
    AsyncPipe,
    TranslateModule,
    UsernamePipe,
    AsyncPipe,
    CommonModule,
    CurrencyPipe,
    NbAutocompleteModule,
    EntityDocumentsTabComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InitiativeFormComponent extends BaseFormComponent implements OnInit, OnDestroy {
  public readonly toDateValue = toDateValue;
  private readonly toIsoDate = toIsoMonthStartDate;

  investmentStatusesService = inject(InvestmentStatusesService);
  private documentsService = inject(DocumentsService);
  private readonly sideFormLevelService = inject(RightPanelDialogService);

  @Input() initiative: Partial<KPI.MappedInitiative>;
  @Input() addMode: boolean = false;
  @Input() wizardForm: FormGroup = null;
  @Input() investment: KPI.MappedInvestment = null;
  @Input() site: KPI.Perimeter;

  // if an initiative has been provided and having status not `demande` or `hypothese`,
  // the form will be read-only
  protected readOnly = false;
  public isLocked: boolean = false;
  public showDocumentsPanel = false;
  public docCount = 0;
  public activeFormTab: 'description' | 'documents' = 'description';

  @ViewChild('firstOptionalField') firstOptionalField: ElementRef;

  public title = this.translate.instant('Initiative-sheet');

  // Tracks whether a save actually happened during this dialog session, so
  // closing without any change doesn't force callers to reload their data.
  private hasSavedChanges = false;

  public minStartDate: string = `${new Date().getFullYear()}-01-01`;
  public maxStartDate: string = `2050-01-01`;
  public initiativePerimeter: KPI.Perimeter = null;

  // hold the value of InvestmentStatus that allowed to this initiative
  public statuses$: Observable<LoadingState<KPI.InitiativeStatus[]>>;

  public initiativeTypes$: Observable<LoadingState<KPI.InitiativeType[]>> = this.initiativesService.initiativeTypes$.pipe(
    map((initiativesTypes) => {
      let sections = [];
      const parents = initiativesTypes.filter((type) => type.parent === null);
      sections = parents.map((parent) => {
        const section = {
          ...parent,
          children: initiativesTypes.filter(
            (type) => type.parent === parent.id
          ),
        };
        return section;
      }).filter((section) => !!section.children?.length);
      return sections.sort((a, b) => a.ordering - b.ordering);
    }),
    toLoadingState<KPI.InitiativeType[]>(),
  );
  public selectedInitiativeType$: Observable<KPI.InitiativeType>;
  public shouldShowQuantity$: Observable<boolean>;
  public confidencesOnFeasibility$: Observable<LoadingState<IdNameMixin[]>> = this.scopeService.confidencesOnFeasibility$.pipe(
    idMapToArray(),
    toLoadingState<IdNameMixin[]>(),
  );
  public tags$: Observable<LoadingState<IdNameMixin[]>> = this.initiativesService.actionTags$.pipe(
    idMapToArray(),
    toLoadingState<IdNameMixin[]>(),
  );
  public users$: Observable<LoadingState<string[]>>;
  public filteredUsers$: Observable<string[]>;
  public isProposedLockedByWorkflow: boolean = false;
  public currency: string = '€';
  private hasPlannedProject: boolean;
  public formatedGains: string = "-";
  public displayValue: string = "";
  public canGoToAudit: boolean;
  public canOpenActionSheet: boolean;
  public gainLabel: string = "";
  private defaultRoadmapIndicators = [];
  private confidencesMap: Map<number, string> = new Map();
  private tagsMap: Map<number, string> = new Map();
  // Fields that must not be saved automatically. We want to show the save button for these.
  private showSaveBtnForTheseFields = [
    'status', 'gains', 'initiative_type', 'savings_start_at'
  ];
  // Text fields or number fields that we want to autoSave, but not each time the user presses a key
  private manualInputFields = [
    'label', 'initially_proposed_by', 'code', 'responsible', 'description'
  ];
  private saveToast = inject(SaveToastService);
  private isBudgetDialogOpen: boolean = false;
  private gainsFormOpen: boolean = false;

  constructor(
    protected nbDialogRef: NbDialogRef<BaseFormComponent>,
    protected dialogService: NbDialogService,
    protected translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private initiativesService: InitiativesService,
    private investmentsService: InvestmentsService,
    private assetsService: AssetsService,
    private scopeService: ScopeService,
    private initiativesChanges: InitiativesChangesService,
    private chartsService: ChartsService,
    private usersService: UsersService,
    private datePipe: DatePipe,
    private i18nService: I18nService,
    private investmentScenariiService: InvestmentScenariiService,
    private formBuilder: FormBuilder,
    private configService: ConfigService,
    private initiativeResponsiblesService: InitiativeResponsiblesService,
    private investmentsChanges: InvestmentsChangesService,
    private roadmapService: RoadmapService,
  ) {
    super(nbDialogRef, dialogService, translate);
    this.currency = this.i18nService.getCurrency();
    this.subscriptions.push(
      this.investmentScenariiService.mainScenario$.subscribe((scenario) => {
        this.hasPlannedProject = this.initiative?.projects?.some((project) =>
          project.instances?.find((i) => i.scenario?.id === scenario.id && i.status?.is_request),
        );
      })
    );
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.subscriptions.push(
      combineLatest([
        this.usersService.hasCurrentUserPermissions([GROUP_PERMISSION_ACCESS_AUDIT]),
        this.configService.customerConfig$
      ]).subscribe(([accessAllowed, config]) => {
        this.canOpenActionSheet = config.open_action_sheet_full_screen && !this.wizardForm
        this.canGoToAudit = accessAllowed && config.can_access_audit_app && !this.wizardForm
      }),


      // Getting the default roadmap indicators in case we have to create an investment
      // for the initiative
      this.roadmapService.roadmapIndicators()
        .subscribe(indicators => {
          const energyIndicator = indicators.find(indicator => indicator.is_energy_carbon);
          if (energyIndicator) {
            this.defaultRoadmapIndicators = [energyIndicator.id];
          }
        })
      )

    if (this.initiative) {
      // Opening an initiative that already exists
      // If the initiative has a past savings_start_at, allow it as the min date
      if (this.initiative.savings_start_at) {
        const existingDate = `${new Date(this.initiative.savings_start_at).getFullYear()}-01-01`;
        if (existingDate < this.minStartDate) {
          this.minStartDate = existingDate;
        }
      }
      this.initialValues = {
        label: this.initiative.label,
        status: this.initiative.status?.id,
        initiative_type: this.initiative.initiative_type?.id,
        confidence_on_feasibility: this.initiative.confidence_on_feasibility,
        perimeter: this.initiative.perimeter?.id,
        savings_start_at: this.initiative.savings_start_at,
        responsible: this.initiative.responsible,
        cee_bonus: this.initiative.cee_bonus,
        yearly_cost_savings: this.initiative.yearly_cost_savings,
        initially_proposed_by: this.initiative.initially_proposed_by,
        code: this.initiative.code,
        description: this.initiative.description,
        quantity: this.initiative.quantity ?? 0,
        tags: this.initiative.tags,
        gains: this.initiative.gains?.map((gain) => ({
          id: gain.id,
          initiative_id: gain.initiative_id,
          energy_type_id: gain.energy_type_id || null,
          refrigerant_type_id: gain.refrigerant_type_id || null,
          gain_origin_id: gain.gain_origin?.id || null,
          gain_precision_id: gain.gain_precision?.id || null,
          theoretical_savings_full_year: gain.theoretical_savings_full_year,
          theoretical_savings_first_year: gain.theoretical_savings_first_year,
          theoretical_greenhouse_gas_savings_full_year: gain.theoretical_greenhouse_gas_savings_full_year,
          theoretical_greenhouse_gas_savings_first_year: gain.theoretical_greenhouse_gas_savings_first_year,
          real_savings: gain.real_savings,
          real_greenhouse_gas_savings: gain.real_greenhouse_gas_savings,
          full_stop: gain.full_stop,
        })) || [],
      };
      this.site = this.initiative.site;
      if (this.site) {
        this.subscriptions.push(
          this.usersService.currentUserHasReadOnlyForSomePerimeters([this.site.id]).subscribe(
            permissions => {
              this.readOnly = permissions?.length > 0;
              this.isLocked = this.initiative?.status?.is_locked || this.readOnly;
              this.updateFormFieldsDisabledState();
            }
          )
        );
      }
      this.isLocked = this.initiative?.status?.is_locked || this.readOnly;

      // Load document count and subscribe to changes
      this.loadDocumentCount();
      this.subscriptions.push(
        this.documentsService._documentsHaveChanged$.subscribe(() => {
          this.loadDocumentCount();
        })
      );
    } else {
      // Coming from the initiative wizard, so the initiative doesn't exists yet.
      this.addMode = true;
      this.readOnly = false;
      this.isLocked = false;
    }

    // If we come from the initiative wizard, the initial values come from the wizard form
    // (initiative-wizard.component).
    // If we open an existing initiative, we initialise the values with it.
    const shouldDisableFields = this.isLocked || this.readOnly;

    this.form = this.wizardForm || this.formBuilder.group({
      label: [
        { value: this.initialValues.label, disabled: shouldDisableFields },
        [Validators.required, Validators.maxLength(255)],
      ],
      status: [
        { value: this.initialValues.status, disabled: this.readOnly },
        [Validators.required],
      ],
      quantity: [
        { value: this.initialValues.quantity, disabled: shouldDisableFields },
        [],
      ],
      initiative_type: [
        { value: this.initialValues.initiative_type, disabled: shouldDisableFields },
        [Validators.required],
      ],
      confidence_on_feasibility: [
        { value: this.initialValues.confidence_on_feasibility, disabled: shouldDisableFields },
        [Validators.required],
      ],
      perimeter: [
        { value: this.initialValues.perimeter, disabled: shouldDisableFields },
        [Validators.required],
      ],
      savings_start_at: [
        { value: this.initialValues.savings_start_at, disabled: shouldDisableFields },
        [Validators.required],
      ],
      // OPTIONAL FIELDS
      cee_bonus: [
        { value: this.initialValues.cee_bonus, disabled: shouldDisableFields },
        [...this.NUMBER_VALIDATORS],
      ],
      yearly_cost_savings: [
        { value: this.initialValues.yearly_cost_savings, disabled: shouldDisableFields },
        [...this.NUMBER_VALIDATORS],
      ],
      responsible: [
        { value: this.initialValues.responsible, disabled: shouldDisableFields },
      ],
      initially_proposed_by: [
        { value: this.initialValues.initially_proposed_by, disabled: shouldDisableFields },
      ],
      tags: [
        { value: this.initialValues.tags, disabled: shouldDisableFields },
      ],
      code: [
        { value: this.initialValues.code, disabled: shouldDisableFields },
      ],
      description: [
        { value: this.initialValues.description, disabled: shouldDisableFields },
      ],
      gains: this.formBuilder.array(
        this.initialValues.gains.map((gain) => this.formBuilder.group({
          ...gain,
        },
        { validators: [gainValidator()] },
        )),
      )
    });

    this.statuses$ = combineLatest([
      this.initiativesService.initiativeStatuses$,
      this.investmentStatusesService.getAllowedTransitionsStatus().pipe(first()),
      this.form.get('savings_start_at').valueChanges.pipe(startWith(this.form.get('savings_start_at').value))
    ]).pipe(
      map(([initiativeStatuses, allowedInvestmentStatuses, savingsStartAt]) => {
         const availableTransitionsIds = allowedInvestmentStatuses
                .filter(t => t.from_status === this.initiative?.status?.id)
                .map(t => t.to_status);

        let filteredStatuses = initiativeStatuses;
        if (this.initiative?.investment) {
          filteredStatuses = initiativeStatuses.filter(s => availableTransitionsIds.includes(s.id) || s.id === this.initiative.status?.id);
        }

        if (savingsStartAt) {
          const date = savingsStartAt instanceof Date
            ? savingsStartAt
            : (savingsStartAt?._d ? new Date(savingsStartAt._d) : new Date(savingsStartAt));
          if (!isNaN(date.getTime())) {
            const savingsStartYear = date.getFullYear();
            const currentYear = new Date().getFullYear();
            const shouldRemoveClosed = savingsStartYear > currentYear;
            if (shouldRemoveClosed) {
              filteredStatuses = filteredStatuses.filter(s => !s.is_closed);
            }
          }
        }

        return filteredStatuses;
      }),
      tap(availableStatuses => {
        // Only disable if no other statuses are available beyond the current one
        const hasOtherStatuses = availableStatuses.some((s: KPI.InitiativeStatus) => s.id !== this.initialValues.status);
        if (!hasOtherStatuses && !this.readOnly) {
          this.form.controls['status'].disable({ emitEvent: false });
        } else if (!this.readOnly) {
          this.form.controls['status'].enable({ emitEvent: false });
        }
      }),
      toLoadingState<KPI.InitiativeStatus[]>(),
      shareReplay(1)
    );

    if (this.addMode) {
      this.statuses$ = this.statuses$.pipe(
        map(statusesState => ({
          ...statusesState,
          data: statusesState.data?.filter(status => status.hypothesis || status.is_request) || []
        }))
      );
    }

    this.displayValue = this.initialValues.responsible || '';

    this.initiativeResponsiblesService.loadResponsibles();

    this.filteredUsers$ = this.form.get('responsible').valueChanges.pipe(
      startWith(''),
      switchMap(value => {
        const filterValue = value?.toLowerCase() || '';
        return this.initiativeResponsiblesService.responsibles$.pipe(
          filter((state: any) => !state.loading),
          map((state: any) => {
            const responsiblesArray: string[] | undefined = state.data;
            if (!responsiblesArray || !Array.isArray(responsiblesArray)) {
              return [];
            }
            const filteredList = responsiblesArray
            .filter(user => user.toLowerCase().includes(filterValue))
            .sort();
            return filteredList
          })
        );
      })
    );

    // Set up available values
    this.setUpAvailableValues();
    // Replace the default backdrop click close event by a custom one
    this.initializeBackdropClick();
    this.updateFormattedGains();

    this.subscriptions.push(
      this.confidencesOnFeasibility$.pipe(first()).subscribe(state => {
        if (state?.data) {
          state.data.forEach((confidence: any) => {
            this.confidencesMap.set(confidence.id, confidence.name);
          });
        }
      }),
      this.tags$.pipe(first()).subscribe(state => {
        if (state?.data) {
          state.data.forEach((tag: any) => {
            this.tagsMap.set(tag.id, tag.name);
          });
        }
      })
    );

    this.selectedInitiativeType$ = combineLatest([
      this.form.get("initiative_type").valueChanges.pipe(startWith(this.form.get("initiative_type").value)),
      this.initiativesService.initiativeTypes$.pipe(first())
    ]).pipe(
      map(([id, types]) => types.find(type => type.id === id)),
      tap(initiativeType => {
        if (initiativeType?.gain_type === "CARBON") {
          this.gainLabel = this.translate.instant("kg CO2 eq/year gain");
        } else {
          this.gainLabel = this.translate.instant("kWh EUE/year gain");
        }
      })
    );

    this.shouldShowQuantity$ = this.selectedInitiativeType$.pipe(
      map(initiativeType => {
        const defaultQuantity = initiativeType?.default_quantity;
        return defaultQuantity != null && defaultQuantity !== 0;
      }),
      shareReplay(1)
    );

    this.subscriptions.push(
      this.selectedInitiativeType$.pipe(
        tap(initiativeType => {
          const quantityControl = this.form.get('quantity');
          const defaultQuantity = initiativeType?.default_quantity;

          if (defaultQuantity == null || defaultQuantity === 0) {
            quantityControl.setValue(0, { emitEvent: false });
            this.initialValues.quantity = 0;
          }
        })
      ).subscribe()
    );

    // Auto-save form changes with debounce (same pattern as fidji-act-comment-dialog)
    // Stream: valueChanges → debounce → compute changes → switchMap to save → update status
    if (!this.addMode && this.initiative?.id) {
      this.subscriptions.push(
        this.form.valueChanges.pipe(
          debounceTime(800),
          filter(() => !this.readOnly && this.form.valid && !this.gainsFormOpen),
          map(() => this._computeChanges()),
          filter(changes => changes.length > 0),
          switchMap(changes => {
            this.setSaving();
            this.initiativesChanges.addChanges(this.initiative.id, changes);
            return this.initiativesChanges.pendingChangesNumber$.pipe(
              filter(nb => !nb),
              first(),
              map(() => changes),
            );
          }),
        ).subscribe({
          next: (changes) => {
            const mustRefreshCapexCharts = !!this.initiative.investment
              && changes.some(c => ['status', 'savings_start_at'].includes(c.property));
            for (const change of changes) {
              if (change.property === 'savings_start_at') {
                this.initialValues[change.property] = this.form.get('savings_start_at').value;
              } else if (change.property === 'gains') {
                this.initialValues[change.property] = this.filterEmptyGains(this.form.get('gains').value);
                this.form.get('gains')?.markAsPristine();
              } else {
                this.initialValues[change.property] = change.value;
              }
              this.initiative[change.property] = change.value;
            }
            if (mustRefreshCapexCharts) { this.chartsService.capexHasChanged(); }
            if (changes.some(c => c.property === 'status')) { this.refreshFormDisabledState(); }
            this.setSaved();
            this.cdRef.detectChanges();
          },
          error: () => {
            this.saveToast.close();
            this.cdRef.detectChanges();
          },
        })
      );
    }

    this.initiativePerimeter = this.site.sub_perimeters?.find(
      perimeter => perimeter.id === this.form.get('perimeter').value
    ) || this.site;
  }

  public onDatepickerMonthChange(date: Date): void {
    this.form.get('savings_start_at')?.setValue(this.toIsoDate(date));
  }

  public formatMonthYear(dateValue: any): string {
    const date = this.toDateValue(dateValue);
    return date ? this.datePipe.transform(date, 'MMMM yyyy') || '-' : '-';
  }

  public onSubmit(): void {
    if (!this.form.valid || this.loading) {
      return;
    }
    this.loading = true;
    this.setSaving();

    // Manage simple field changes
    const changes: { property: string, value: any }[] = Object.keys(this.initialValues)
      .filter((key) => this.fieldValueChanged(key))
      .map((key: string) => {
        let value = key !== 'savings_start_at'
          ? this.form.get(key).value
          : this.datePipe.transform(this.form.get(key).value, "yyyy-MM-dd");

        if (key === 'gains') {
          value = this.filterEmptyGains(value);
          if (this.initiative?.id) {
            value = value.map((gain: any) => {
              if (!gain.id && !gain.initiative_id) {
                return { ...gain, initiative_id: this.initiative.id };
              }
              return gain;
            });
          }
        }

        return {
          property: key,
          value: value,
        };
      });

    // UPDATE INITIATIVE
    if (this.initiative?.id) {
      this.initiativesChanges.addChanges(this.initiative.id, changes);
      const mustRefreshCapexCharts = !!this.initiative.investment
        && changes.some((change) => ['status', 'savings_start_at'].includes(change.property));
      this.initiativesChanges.pendingChangesNumber$.pipe(
        filter((nb) => !nb),
        first(),
        switchMap(() => {
          let patchInvestment$ = of(null);
          changes.map((change) => {
            if (change.property === "savings_start_at") {
              this.initialValues[change.property] = this.form.get('savings_start_at').value;
            } else if (change.property === "gains") {
              const filteredGains = this.filterEmptyGains(this.form.get('gains').value);
              this.initialValues[change.property] = filteredGains;
              const gainsControl = this.form.get('gains');
              if (gainsControl) {
                gainsControl.markAsPristine();
              }
            } else {
              this.initialValues[change.property] = change.value
            }
            this.initiative[change.property] = change.value;
          });
          return patchInvestment$;
        })
      ).subscribe(() => {
        if (mustRefreshCapexCharts) {
          this.chartsService.capexHasChanged();
        }

        if (changes.some(change => change.property === 'status')) {
          this.refreshFormDisabledState();
        }

        this.loading = false;
        this.hasSavedChanges = true;
        this.setSaved();
        this.cdRef.detectChanges();
      });
    } else {
      let createInitiative$: Observable<KPI.Initiative | number>;
      if (this.investment?.slices[0].price) {
        this.investment.label = this.form.controls["label"].value;
        createInitiative$ = this.investmentsService.createInvestment(this.investment).pipe(
          switchMap(invest => {
            // CREATE INITIATIVE
            const formData = { ...this.form.value };
            formData.gains = this.filterEmptyGains(formData.gains);
            return this.initiativesService.createInitiative(formData).pipe(
              switchMap(newInitiative => {
                // Attach investment afterward because the backend doesn't do it during
                // the creation process
                const change = [{ property: "investment", value: invest.id }]
                this.initiativesChanges.addChanges(newInitiative.id, change);
                return this.initiativesChanges.pendingChangesNumber$.pipe(
                  filter((nb) => !nb),
                  first(),
                  switchMap(() => {
                      // TODO: patch the initiative field of the investment. Currently not working
                      const investChanges = [{
                        property: "initiative",
                        value: {
                          id: newInitiative.id,
                          label: newInitiative.label,
                          initiative_type: newInitiative.initiative_type,
                          status: newInitiative.status,
                          gains: newInitiative.gains
                        }
                      }];
                      return this.patchInvestment(invest.id, investChanges);
                    })
                )
              })
            )
          })
        )
      } else {
        // No budget, so we create the initiative without investment
        const formData = { ...this.form.value };
        formData.gains = this.filterEmptyGains(formData.gains);
        createInitiative$ = this.initiativesService.createInitiative(formData)
      }
      createInitiative$.subscribe((newInitiative) => {
        this.chartsService.capexHasChanged();
        this.close(newInitiative);
      });
    }
  }

  private patchInvestment(investmentId: number, investmentChanges: any): Observable<any> {
    this.investmentsChanges.addChanges(investmentId, investmentChanges);
    return this.investmentsChanges.pendingChangesNumber$.pipe(
      filter(nb => !nb),
      first()
    );
  }

  /** Open an iframe to show the capex audit */
  public goToAudit(): void {
    this.initiativesService.openAuditInitiativeEditor({
      initiativeId: this.initiative.id,
      siteId: this.initiative.site.id,
    })
  }

  protected setUpAvailableValues(): void {
    // USERS FOR RESPONSIBLE FIELD
    this.users$ = this.usersService.allUsers$.pipe(
      map((users) => {
        return users.filter((user) => {
          const canAccessThisSite = user.perimeter_permissions.find(
            (p) => p.perimeter === this.site.id
          );
          return !!canAccessThisSite;
        });
      }),
      toLoadingState<string[]>(),
    );
  }

  // If initiative not currently in hypothesis status,
  // and there is an investment linked to the initiative
  // which the status has 'related_initiative_can_be_unplanned' set to false,
  // then the initiative status cannot be changed to hypothesis
  public isStatusDisabled(targetInitiativeStatus: KPI.InitiativeStatus): Observable<boolean> {
    return combineLatest([
      this.statuses$.pipe(filter((state) => !state.loading), map((state) => state.data)),
      this.scopeService.user$,
      this.usersService.currentUserGroups$,
      this.scopeService.investmentStatuses$.pipe(idMapToArray()),
    ]).pipe(
      map(([initiativeStatuses, user, userGroups, investmentStatuses]) => {
        const investment = this.initiative?.investment;
        const currentInitiativeStatus = initiativeStatuses.find(
          (initiativeStatus) =>
            initiativeStatus.id === this.form.controls["status"].value
        );
        if (!investment) return false;
        if (!user || !userGroups?.length) return true;
        const investmentStatus = investmentStatuses.find(
          (investmentStatus) =>
            // @ts-ignore
            investmentStatus.id === investment.status
        );

        let isInvestmentTransitionAllowed = true;
        if (investmentStatus?.related_initiative_can_be_unplanned === false) {
          isInvestmentTransitionAllowed = false;
        }

        if (
          targetInitiativeStatus?.hypothesis ||
          targetInitiativeStatus?.is_request
        ) {
          const targetInvestmentStatus = this.findMatchingInvestmentStatus(
            targetInitiativeStatus,
            investmentStatuses,
          );

          if (investmentStatus && targetInvestmentStatus) {
            isInvestmentTransitionAllowed = !!this.investmentsService
              .filterInvestmentStatusByTransition(
                investmentStatus,
                investmentStatuses,
                user,
                userGroups
              )
              .concat([investmentStatus])
              .find((status) => status.id === targetInvestmentStatus.id);
          }
          return !(
            isInvestmentTransitionAllowed
            && (
              !targetInitiativeStatus.hypothesis
              || (
                !currentInitiativeStatus?.hypothesis
                && targetInitiativeStatus.hypothesis
                && investmentStatus?.related_initiative_can_be_unplanned
              )
            )
          ) || (
            targetInitiativeStatus.hypothesis && this.hasPlannedProject
          ) // Disable hypothesis status if the investment is part of a planned project;
        } else {
          return false;
        }
      })
    );
  }

  private findMatchingInvestmentStatus(
    status: KPI.InitiativeStatus,
    investmentStatuses: KPI.InvestmentStatus[],
  ): KPI.InvestmentStatus {
    if (status.hypothesis) {
      return investmentStatuses.find(
        (investmentStatus) => investmentStatus.hypothesis
      );
    } else if (status.is_request) {
      return investmentStatuses.find(
        // @ts-ignore
        (investmentStatus) => investmentStatus.is_request
      );
    }
    return null;
  }

  public openGainsForm(): void {
    if (this.readOnly) {
      return;
    }
    if (this.isProposedLockedByWorkflow || this.isLocked) {
      this.showLockedInitiativeDialog();
      return;
    }
    const previousValue = this.cloneGainsSnapshot(this.form.get('gains').value);
    this.gainsFormOpen = true;
      this.sideFormLevelService.open(
        InitiativeGainsFormComponent,
        {
          autoFocus: false,
          closeOnBackdropClick: false,
          context: {
            initiativeForm: this.form,
            initiativeId: this.addMode ? null : this.initiative.id,
            siteId: this.site?.id,
          },
        },
      ).onClose.subscribe((data) => {
        this.gainsFormOpen = false;
        if (data?.saved) {
          if (this.initiative.id) {
            this.onSubmit();
          }
        } else {
          // If the user didn't click 'save', restore previous gains exactly.
          this.restoreGainsSnapshot(previousValue);
        }
        this.cdRef.detectChanges()
      });
  }

  private cloneGainsSnapshot(gains: any[]): any[] {
    return JSON.parse(JSON.stringify(gains || []));
  }

  private restoreGainsSnapshot(gainsSnapshot: any[]): void {
    const gainsArray = this.form.get('gains') as FormArray;
    if (!gainsArray) {
      return;
    }

    while (gainsArray.length) {
      gainsArray.removeAt(0);
    }

    gainsSnapshot.forEach((gain) => {
      gainsArray.push(
        this.formBuilder.group(
          { ...gain },
          { validators: [gainValidator()] },
        ),
      );
    });

    gainsArray.markAsPristine();
    gainsArray.updateValueAndValidity({ emitEvent: true });
  }

  public anyFieldValueChanged(): boolean {
    let allowAutoSave: boolean = true;
    const anyFieldChanged = Object.keys(this.initialValues).some((key: string) => {
      if (this.manualInputFields.includes(key)) {
        // We don't want the autoSave function to be triggered for each key the user types
        // but we don't want to show the save button either
        return false;
      }
      const hasChanged = this.fieldValueChanged(key);
      if (hasChanged && this.showSaveBtnForTheseFields.includes(key)) {
        allowAutoSave = false;
      }
      return hasChanged;
    });
    if (anyFieldChanged && allowAutoSave && !this.addMode) {
      this.autoSave();
      return false;
    }
    return anyFieldChanged || this.addMode;
  }

  /**
   * anyFieldValueChanged() always reports "changed" while in add mode, so that the
   * "Create action" button (gated on it in the template) stays enabled even before
   * the wizard/nomenclature defaults are edited. That makes it unusable as-is to
   * decide whether closing the form would actually discard something.
   */
  protected override hasUnsavedChanges(): boolean {
    if (!this.addMode) {
      return super.hasUnsavedChanges();
    }
    if (this.wizardForm) {
      // The wizard-driven flow reuses the wizard's own form with no initial
      // snapshot to diff against, and closing here would discard that
      // multi-step wizard's progress, so always treat it as unsaved.
      return true;
    }
    return Object.keys(this.initialValues).some((key: string) => {
      if (this.manualInputFields.includes(key)) {
        return false;
      }
      return this.fieldValueChanged(key);
    });
  }

  public isFormValid(): boolean {
    return this.form.valid;
  }

  public onResponsibleSelected(user: string): void {
    this.displayValue = user;
    this.form.get("responsible").setValue(user);
    this.autoSave('responsible');
  }

  public onResponsibleInput(event: any): void {
    const value = event.target.value;
    this.displayValue = value;
    this.form.get("responsible").setValue(value);
  }

  static gainValidator(initiativeType: KPI.InitiativeType = null) {
    return (gain: FormGroup) => {
      const energy = gain.get("energy_type_id")?.value;
      const co2Gain = gain.get("theoretical_greenhouse_gas_savings_full_year")?.value;
      const refrigerant = gain.get("refrigerant_type_id")?.value;
      const energyGain = gain.get("theoretical_savings_full_year")?.value;

      if (!energy && !co2Gain && !refrigerant && !energyGain && initiativeType?.gain_type === "None") {
        return null;
      }

      if (initiativeType?.gain_type === "ENERGY") {
        const hasEnergy = !!energy;
        const hasGain = !!(energyGain && energyGain !== 0 && energyGain !== '');

        if (!hasEnergy && !hasGain) {
          return null;
        }

        if (hasEnergy && !hasGain) {
          return { gainValueRequired: { required: true } };
        }
        if (hasGain && !hasEnergy) {
          return { energyOrRefrigerant: { required: true } };
        }
      } else if (initiativeType?.gain_type === "CARBON") {
        const hasRefrigerant = !!refrigerant;
        const hasGain = !!(co2Gain && co2Gain !== 0 && co2Gain !== '');

        if (!hasRefrigerant && !hasGain) {
          return null;
        }

        if (hasRefrigerant && !hasGain) {
          return { gainValueRequired: { required: true } };
        }
        // No error when only the kgCO2 value is filled: the CARBON form has no
        // refrigerant fluid input, so the user has no way to satisfy such a requirement.
      } else if (initiativeType?.gain_type === "QUIT_FOSSIL") {
        return null;
      }

      return null;
    };
  }

  private filterEmptyGains(gains: any[]): any[] {
    if (!gains || !Array.isArray(gains)) {
      return [];
    }

    return gains.filter(gain => {
      if (!gain || typeof gain !== 'object') {
        return false;
      }

      const hasData = Object.keys(gain).some(key => {
        const value = gain[key];
        return value !== null && value !== undefined && value !== '' && value !== false;
      });

      return hasData;
    });
  }

  private updateFormattedGains() {
    // On form initiative_type change or gains change, update the formatted gains
    combineLatest([
      this.form.get('initiative_type').valueChanges.pipe(startWith(this.form.get('initiative_type').value)),
      this.form.get('gains').valueChanges.pipe(startWith(this.form.get('gains').value)),
      this.initiativesService.initiativeTypes$.pipe(first()),
    ]).subscribe(([initiativeTypeId, gains, initiativeTypes]) => {
      const initiativeType = initiativeTypes.find(initiativeType => initiativeType.id === initiativeTypeId);
      if (!gains?.length || initiativeType.gain_type === 'None') {
        this.formatedGains = "-";
      } else if (initiativeType?.gain_type === 'QUIT_FOSSIL') {
        this.formatedGains = this.translate.instant('Abandon');
      } else if (initiativeType.gain_type === 'ENERGY') {
        const totalGainkWh = gains.reduce((acc, gain) => acc + gain.theoretical_savings_full_year, 0);
        this.formatedGains = this.translate.instant(
          '{savings} kWh (expected gain)',
          {
            savings: formatNumber(totalGainkWh, this.i18nService.getCulture()),
          }
        );
      } else if (initiativeType.gain_type === 'CARBON') {
        const totalGainCO2 = gains.reduce((acc, gain) => acc + gain.theoretical_greenhouse_gas_savings_full_year, 0);
        this.formatedGains = this.translate.instant(
          '{savings} kg eq CO2 (expected gain)',
          {
            savings: formatNumber(totalGainCO2, this.i18nService.getCulture()),
          }
        );
      } else {
        this.formatedGains = "-";
      }

      // Component uses OnPush, so ensure UI is refreshed immediately after gains updates.
      this.cdRef.detectChanges();
    });
  }

  public openBudgetForm() {
    if (this.isBudgetDialogOpen) {
      return;
    }
    if (this.isProposedLockedByWorkflow || this.readOnly || this.isLocked) {
      this.showLockedInitiativeDialog();
      return;
    }
    this.isBudgetDialogOpen = true;

    let getInvestment$: Observable<any>;
    if (this.initiative?.investment) {
      // Get the "mapped" investment (because the initiative.investment doesn't have the
      // correct format for the budget component)
      const investment = { ...this.initiative.investment };
      let assetId: number | null = null;
      if (investment.asset != null) {
        if (typeof investment.asset === 'object') {
          assetId = (investment.asset as any)?.id ?? null;
        } else if (typeof investment.asset === 'number') {
          assetId = investment.asset;
        }
      }

      if (assetId !== null) {
        investment.asset = assetId;
      }

      const asset$ = assetId
        ? this.assetsService.getAsset(assetId).pipe(
            catchError(() => of(null))
          )
        : of(null);

      getInvestment$ = asset$.pipe(
        switchMap((asset) => {
          const assets = asset ? [asset] : [];
          return this.investmentsService.mapInvestments([investment], assets);
        }),
        map(investments => investments[0])
      )
    } else if (this.investment) {
      getInvestment$ = of(this.investment);
    } else {
      // Automatically create an investment for the initiative
      const actionDate = this.form.controls["savings_start_at"].value;
      const actionYear = actionDate ? new Date(actionDate).getFullYear() : null;
      const dataForInvestment = {
        label: this.form.controls["label"].value,
        multi_perimeter: this.initiative.site,
        building: this.initiative.perimeter.building_id,
        initiative: {
          id: this.initiative.id,
          label: this.initiative.label,
          initiative_type: this.initiative.initiative_type.id,
          status: this.initiative.status.id,
          gains: this.initiative.gains
        },
        is_capex: true,
        impact_roadmap_indicators: this.defaultRoadmapIndicators,
        ...(actionYear && !isNaN(actionYear) ? { initial_schedule: actionYear } : {}),
      };
      getInvestment$ = this.investmentsService.makeMappedInvestment(dataForInvestment);
    }
    this.subscriptions.push(
      getInvestment$.subscribe(
        mappedInvestment => {
          const dialogRef = this.sideFormLevelService.open(
            InvestmentFormComponent,
            {
              autoFocus: false,
              closeOnBackdropClick: false,
              context: {
                investment: mappedInvestment,
                initiative: true,
                initiativeId: this.initiative.id,
              },
            }
          );

          dialogRef.onClose.subscribe((result: any) => {
            this.isBudgetDialogOpen = false;

            if (result && result.deleted === true) {
              if (this.initiative?.investment) {
                const change = [{ property: "investment", value: null }];
                this.initiativesChanges.addChanges(this.initiative.id, change);
                this.initiative.budget = 0;
                this.initiative.investment = null;
                this.chartsService.capexHasChanged();
                this.cdRef.detectChanges();
              }
              return;
            }

            // New budget flow returns the saved investment object.
            if (result?.investment) {
              const updatedInvestment = result.investment;
              if (this.initiative) {
                this.initiative.investment = updatedInvestment;
                this.initiative.budget = this.investmentsService.getInvestmentBudget(updatedInvestment) as number;
              }
              this.investment = updatedInvestment;
              this.chartsService.capexHasChanged();
              this.cdRef.detectChanges();
              return;
            }

            if (!result) {
              return;
            }

            const investmentForm = result as UntypedFormGroup;
            if (investmentForm?.dirty) {
              if (this.initiative) {
                this.initiative.budget = investmentForm.controls['price'].value ? investmentForm.controls['price'].value : 0;
                if (this.initiative.investment) {
                  if (!investmentForm.controls['price'].value) {
                    // Investment has been deleted
                    const change = [{ property: "investment", value: null }]
                    this.initiativesChanges.addChanges(this.initiative.id, change);
                    this.initiative.investment = null;
                  } else {
                    // Keep local investment in sync so reopening budget uses fresh values.
                    this.initiative.investment = this.getDataFromInvestmentForm(investmentForm, this.initiative.investment as KPI.MappedInvestment);
                  }
                  this.chartsService.capexHasChanged();
                  this.cdRef.detectChanges();
                } else if (investmentForm.controls['price'].value) {
                  // Initiative doesn't have an investment yet. Create one so we can save the budget.
                  this.investment = this.getDataFromInvestmentForm(investmentForm, mappedInvestment);
                  if (this.initiative.id) {
                    // Save the new investment and attach it to the initiative
                    this.investmentsService.createInvestment(this.investment).pipe(
                      switchMap(newInvestment => {
                        const statusId = this.getInitiativeStatusIdFromInvestment(newInvestment);
                        const change = [
                          { property: "investment", value: newInvestment.id },
                          { property: "savings_start_at", value: this.getInitiativeDateFromInvest(newInvestment) },
                          { property: "status", value: statusId }
                        ]
                        this.form.patchValue({
                          "savings_start_at": this.getInitiativeDateFromInvest(newInvestment),
                          "status": statusId
                        });
                        this.initialValues['savings_start_at'] = this.form.get('savings_start_at').value;
                        this.initialValues['status'] = statusId;
                        this.initiative.investment = newInvestment;
                        this.setSaving();
                        this.initiativesChanges.addChanges(this.initiative.id, change);
                        return this.initiativesChanges.pendingChangesNumber$.pipe(
                          filter((nb) => !nb),
                          first(),
                        )
                      })
                    ).subscribe(() => {
                      this.setSaved();
                      this.chartsService.capexHasChanged();
                      this.cdRef.detectChanges();
                    })
                  }
                }
              } else {
                // No initiative, we are in the initiative wizard. Just update the investment, it will be
                // saved and attached when the user clicks submit.
                this.investment = this.getDataFromInvestmentForm(investmentForm, mappedInvestment);
                this.cdRef.detectChanges();
              }
            }
          });
        },
        () => {
          this.isBudgetDialogOpen = false;
        }
      )
    )
  }

  public getInitiativeBudget(): number {
    if (this.initiative) {
      return this.initiative.budget;
    }
    const budget = this.investment?.slices[0].price;
    return typeof budget === 'string' ? parseInt(budget) : budget;
  }

  public getDataFromInvestmentForm(investmentForm: FormGroup, investment: KPI.MappedInvestment) {
    investment.budget_origin = investmentForm.controls["budget_origin"].value;
    investment.slices[0] = {
      id: null,
      year: investmentForm.controls["year"].value,
      price: investmentForm.controls["price"].value,
      status: investmentForm.controls["status"].value
    };
    investment.budget_scopes = investmentForm.controls["budget_scopes"].value;
    return investment;
  }

  public openActionSheet(): void {
    this.dialogService.open(
      SheetDialogComponent,
      {
        autoFocus: false,
        context: {
          initiativeId: this.initiative.id,
        },
      }
    );
  }

  private refreshFormDisabledState(): void {
    const statusId = this.form.get('status').value;
    if (!statusId) {
      return;
    }

    this.initiativesService.initiativeStatuses$.pipe(first()).subscribe(statuses => {
      const newStatus = statuses.find(s => s.id === statusId);
      if (newStatus) {
        this.initiative.status = newStatus;

        const isLocked = newStatus.is_locked || this.readOnly;
        this.isLocked = isLocked;

        this.updateFormFieldsDisabledState();
      }
    });
  }

  private updateFormFieldsDisabledState(): void {
    if (!this.form) {
      return;
    }
    const shouldDisableFields = this.isLocked || this.readOnly;

    const fieldsToUpdate = [
      'label', 'quantity', 'initiative_type', 'confidence_on_feasibility',
      'perimeter', 'savings_start_at', 'cee_bonus', 'yearly_cost_savings',
      'responsible', 'initially_proposed_by', 'tags', 'code', 'description'
    ];

    fieldsToUpdate.forEach(fieldName => {
      const control = this.form.get(fieldName);
      if (control) {
        if (shouldDisableFields) {
          control.disable({ emitEvent: false });
        } else {
          control.enable({ emitEvent: false });
        }
      }
    });

    const statusControl = this.form.get('status');
    if (statusControl) {
      if (this.readOnly) {
        statusControl.disable({ emitEvent: false });
      } else {
        statusControl.enable({ emitEvent: false });
      }
    }
  }

  getStatusDisplay(): string {
    if (!this.form?.get('status')?.value) return '-';
    const status = this.initiative?.status;
    return status?.name || '-';
  }

  getInitiativeTypeDisplay(): string {
    if (!this.form?.get('initiative_type')?.value) return '-';
    const initiativeType = this.initiative?.initiative_type;
    return initiativeType?.friendly_name || initiativeType?.setup_reference || '-';
  }

  getConfidenceOnFeasibilityDisplay(): string {
    if (!this.form?.get('confidence_on_feasibility')?.value) return '-';
    const confidenceId = this.form.get('confidence_on_feasibility').value;
    return this.confidencesMap.get(confidenceId) || '-';
  }

  getTagsDisplay(): string {
    if (!this.form?.get('tags')?.value) return '-';
    const tagIds = this.form.get('tags').value;
    if (!Array.isArray(tagIds) || tagIds.length === 0) return '-';
    const tagNames = tagIds
      .map((id: number) => this.tagsMap.get(id))
      .filter((name: string | undefined) => name);
    return tagNames.length > 0 ? tagNames.join(', ') : '-';
  }

  public showLockedInitiativeDialog() {
    if (!this.isLocked) {
      return;
    }
    const content = this.translate.instant('Given the status some fields are not editable');
    this.dialogService.open(
      BasicDialogComponent,
      {
        autoFocus: false,
        context: {
          title: this.translate.instant('Unauthorised modification'),
          content: content,
          canCancel: false
        },
      },
    );
  }

  public autoSave(field?: string) {
    // Auto-save is now handled by the form.valueChanges stream with debounce.
    // This method is kept for backward compatibility (e.g. onResponsibleSelected).
    // Triggering updateValueAndValidity will emit valueChanges, picked up by the stream.
    if (field && !this.fieldValueChanged(field)) {
      return;
    }
    this.form.updateValueAndValidity();
  }

  private _computeChanges(): { property: string, value: any }[] {
    return Object.keys(this.initialValues)
      .filter(key => this.fieldValueChanged(key))
      .map(key => {
        let value = key !== 'savings_start_at'
          ? this.form.get(key).value
          : this.datePipe.transform(this.form.get(key).value, 'yyyy-MM-dd');
        if (key === 'gains') {
          value = this.filterEmptyGains(value);
          if (this.initiative?.id) {
            value = value.map((gain: any) => {
              if (!gain.id && !gain.initiative_id) {
                return { ...gain, initiative_id: this.initiative.id };
              }
              return gain;
            });
          }
        }
        return { property: key, value };
      });
  }

  private setSaving(): void {
    this.saveToast.showSaving();
  }

  private setSaved(): void {
    this.saveToast.showSaved();
  }

  public loadDocumentCount(): void {
    if (!this.initiative?.id) return;
    this.subscriptions.push(
      this.documentsService.getDocumentsCount(
        [],
        [],
        [this.initiative.id],
        []
      ).subscribe((count) => {
        this.docCount = count;
        this.cdRef.detectChanges();
      })
    );
  }

  public toggleDocumentsPanel(): void {
    this.showDocumentsPanel = !this.showDocumentsPanel;
  }

  public onDocumentsDrawerClosed(): void {
    this.showDocumentsPanel = false;
    this.loadDocumentCount();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public override close(result?: unknown): void {
    // Cancel / view-only close (e.g. the X button) doesn't pass a result —
    // default it to whether a save actually happened, so callers watching
    // onClose can skip reloading when nothing changed.
    super.close(result !== undefined ? result : this.hasSavedChanges);
  }

  public openInvestment() {
    const dialog = this.sideFormLevelService.open(LinkableInvestmentsListComponent, {
      autoFocus: false,
      context: {
        initiative: this.initiative,
        linkedToId: null,
        perimeter: this.site,
        startYear: 1950,
        endYear: 2100,
        inputLinkedElementIds: [],
        readOnly: this.readOnly,
        multipleChoice: false
      },
    });

    dialog.onClose.pipe().subscribe((result) => {
      if (result === 'new') {
        // Let the user create a new investment by showing him the budget component
        this.openBudgetForm();
      } else if (result?.length === 1) {
        this.linkInvestmentToInitiative(result[0]);
      } else if (result?.length === 0) {
        this.cdRef.detectChanges();
      }
    });
  }

  private linkInvestmentToInitiative(investId: number) {
    if (investId === this.initiative.investment?.id) {
      // No need to attach it again
      return;
    }
    this.investmentsService.getInvestmentsByIds([investId]).subscribe(investments => {
      const investment = investments[0];
      const budget = this.investmentsService.getInvestmentBudget(investment);
      this.initiative.investment = investment;
      this.initiative.budget = budget as number;
      const initiativeNewDate = this.getInitiativeDateFromInvest(investment);
      const statusId = this.getInitiativeStatusIdFromInvestment(investment);
      this.form.patchValue({
        status: statusId,
        savings_start_at: initiativeNewDate,
        budget: budget
      });
      const change = [
        { property: "investment", value: investment.id },
      ]
      this.initiativesChanges.addChanges(this.initiative.id, change);
      this.onSubmit();
      this.cdRef.detectChanges();
    })
  }

  getInitiativeDateFromInvest(investment: KPI.Investment) {
    let initiativeDate: string = this.initiative ? this.initiative.savings_start_at
      : this.form.get('savings_start_at').value;
    const dateSplit = initiativeDate.split("-");
    const newDate = investment.initial_schedule + "-" + dateSplit[1] + "-" + dateSplit[2];
    return newDate;
  }

  /**
   * Sometimes the status type is an object but the variable is declared as a number
   */
  getInitiativeStatusIdFromInvestment(investment: any): number {
    if (typeof investment.status === "object") {
      return investment.status.id;
    } else if (typeof investment.status === "number") {
      return investment.status;
    }
  }
}
